(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/*global module */
/*jshint devel:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.qpall = exports.redir2secOnHost = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getUrlQstringPairs = getUrlQstringPairs;
exports.getQstringValue = getQstringValue;
exports.addPolyfill = addPolyfill;
exports.getDomOffset = getDomOffset;
exports.ensureWithPolyfill = ensureWithPolyfill;
exports.canGetBrowserLoc = canGetBrowserLoc;
exports.requestLatLonBrowserData = requestLatLonBrowserData;
exports.matchAnyHost = matchAnyHost;
exports.isDevHost = isDevHost;
exports.RedirectToSecureHelper = RedirectToSecureHelper;
exports.docUrlWatcher = docUrlWatcher;

var _DryFunctions = require('./DryFunctions.es6');

var cerr = console.error;
var clo = console.log;

function getUrlQstringPairs() {
    var qsSplit = [],
        qsPairs = {},
        s = document.location.search;
    s = s.substring(1);
    if (s) {
        qsSplit = s.split('&');
        if (qsSplit && qsSplit.length) {
            qsSplit.forEach(function (kvp) {
                var _kvp$split = kvp.split('='),
                    _kvp$split2 = _slicedToArray(_kvp$split, 2),
                    k = _kvp$split2[0],
                    v = _kvp$split2[1];

                qsPairs[k] = v;
            });
        }
    }
    return qsPairs;
}
function getQstringValue(key) {
    var retVal = void 0;
    var pairs = getUrlQstringPairs();
    if (pairs && Object.keys(pairs) && Object.keys(pairs).length) {
        if (Object.keys(pairs).includes(key)) {
            retVal = pairs[key];
        }
    }
    return retVal;
}

function addPolyfill(name) {
    var haveIt = false,
        url = void 0,
        hasPromise = window.Promise ? true : false;
    switch (name) {
        case 'promise':
            url = 'https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.min.js';
            haveIt = true;
            break;
        case 'NodeList.forEach':
            url = 'https://cdn.jsdelivr.net/npm/mdn-polyfills@5.5.0/NodeList.prototype.forEach.js';
            haveIt = true;
            break;
        default:
            throw new Error('unsupported polyfill: ' + name + ' - MO+7DVfmY');
    }
    var prom = false;
    if (haveIt) {
        var scr = document.createElement('script');
        scr.setAttribute('src', url);
        if (hasPromise) {
            prom = new Promise(function (resolve, reject) {
                scr.addEventListener('load', function () {
                    resolve();
                });
            });
        }
        document.querySelector('head').appendChild(scr);
        console.log('%cPolyfilling ' + name, 'font-size:1.6em;color:purple');
        console.log('%c' + url, 'font-size:1.3em;color:purple');
    }
    return prom;
}

function getDomOffset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft, height: rect.height, width: rect.width };
}

function ensureWithPolyfill(name) {
    switch (name) {
        case 'promise':
            if (!window.Promise) {
                addPolyfill(name);
            }
            break;
        case 'NodeList.forEach':
            if (!NodeList.prototype.forEach) {
                return addPolyfill(name);
            }
            break;
        default:
            throw new Error('unsupported polyfill: ' + name + ' - ZdLNN-9-hu');
    }
}

/**
 * Checks Browser to see if geolocation is available. If so, returns the "state" of geolocation availability (see below).
 * Returns Promise. on success returns {success: true|false, state:'granted'|'prompt|'denied'}, on error returns string describing problem
 * @return {Promise} on success: object: {success: true|false, state:'granted'|'prompt|'denied'}, on error: string describing problem
 */
function canGetBrowserLoc() {
    return new Promise(function (resolv, rej) {
        var q = void 0;
        var n = 'navigator.permissions.query';
        try {
            q = navigator.permissions.query({ name: 'geolocation' });
            q.then(function (permStat) {
                // console.log('nav.perms.query.then: ', q, permStat, permStat.state);
                if (permStat && permStat.state) {
                    if (['granted', 'prompt'].includes(permStat.state)) {
                        resolv({
                            success: true,
                            state: permStat.state
                        });
                    } else {
                        rej(n + ' state was UNKNOWN: ', permStat);
                    }
                } else {
                    rej(n + ' state was: ', permStat);
                }
            }, function (e) {
                console.error('ERROR in ' + n + ': ', e);
            });
        } catch (e) {
            rej(n + ' must have failed: ', e);
        }
    });
}

function requestLatLonBrowserData() {
    return new Promise(function (resolv, rej) {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                resolv(position);
            }, function (errPos) {
                rej(errPos);
            });
        } else {
            rej();
        }
    });
}

// REDIRECT TO https: if not dev environment
var devHosts = ['localhost', 'ormsby', 'chriso'];

function matchAnyHost(a) {
    if (!(0, _DryFunctions.isArray)(a)) {
        return;
    }
    var iz = false;
    a.forEach(function (s) {
        if (window.location.hostname.match(s)) {
            iz = true;
        }
    });
    return iz;
}
function _redir2secOnHost(hstArr) {
    if (hstArr && !(0, _DryFunctions.isArray)(hstArr)) {
        return;
    }
    var myDevHosts = hstArr || devHosts;
    if (!matchAnyHost(myDevHosts) && window.location.protocol !== 'https:') {
        window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
    }
}

exports.redir2secOnHost = _redir2secOnHost;
function isDevHost(hstArr) {
    var myDevHosts = hstArr || devHosts;
    return matchAnyHost(myDevHosts);
}

// constructor
function RedirectToSecureHelper() {
    var myDevHosts = devHosts;
    var R2S = {
        setDevHosts: function setDevHosts(hostsArr) {
            try {
                if (!Array.isArray(hostsArr)) {
                    cerr('Browser(helper).setDevHosts failed.  Bad arg: ', hostsArr);return;
                }
            } catch (e) {
                cerr('9>/oNoreEP');
            }
            myDevHosts = hostsArr;
        },
        getDevHosts: function getDevHosts() {
            return myDevHosts;
        },
        resetDevHosts: function resetDevHosts() {
            myDevHosts = devHosts;
        },
        isDevHost: function isDevHost() {
            return matchAnyHost(myDevHosts);
        },
        redir2secOnHost: function redir2secOnHost() {
            return _redir2secOnHost(myDevHosts);
        },
        help: function help() {
            for (var att in R2S) {
                if (typeof R2S[att] === 'function') {
                    clo('func ' + att);
                }
            }
        }
    };
    return R2S;
}

function docUrlWatcher() {
    var CALLBACKS = {};
    var DUW = {
        registerUrlWatcher: function registerUrlWatcher(cb) {
            CALLBACKS.popstate = cb;
            // window.addEventListener('popstate', function(e){
            //     console.log('URL CHANGED: ',e);
            //     CALLBACKS.popstate(e);
            // });
            window.onpopstsate = function (e) {
                console.log('URL CHANGED: ', e);
                CALLBACKS.popstate(e);
            };
        },
        registerHashWatcher: function registerHashWatcher(cb) {
            CALLBACKS.hashchange = cb;
            // window.addEventListener('hashchange', function(e){
            //     console.log('URL CHANGED: ',e);
            //     CALLBACKS.hashchange(e);
            // });
            window.onhashchange = function (e) {
                console.log('URL CHANGED: ', e);
                CALLBACKS.hashchange(e);
            };
        }
    };
    return DUW;
}

var qpall = exports.qpall = {
    encode: function encode(str) {
        return encodeURIComponent(str).replace(/[!'()]/g, window.escape).replace(/\*/g, "%2A").replace(/[.]/g, "%2E").replace(/%/g, '=');
    },
    decode: function decode(str) {
        return decodeURIComponent(str.replace(/[=]/g, '%'));
    }
};

module.exports = {
    getUrlQstringPairs: getUrlQstringPairs,
    getQstringValue: getQstringValue,
    addPolyfill: addPolyfill,
    getDomOffset: getDomOffset,
    ensureWithPolyfill: ensureWithPolyfill,
    canGetBrowserLoc: canGetBrowserLoc,
    requestLatLonBrowserData: requestLatLonBrowserData,
    isDevHost: isDevHost,
    RedirectToSecureHelper: RedirectToSecureHelper,
    docUrlWatcher: docUrlWatcher,
    qpall: qpall
};

},{"./DryFunctions.es6":3}],2:[function(require,module,exports){
/*global module, console */
/*jshint devel:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeNode = makeNode;
exports.makeNodesByTagname = makeNodesByTagname;
exports.FreezeBody = FreezeBody;

var _DryFunctions = require('./DryFunctions.es6');

function makeNode(opts) {
    var html = void 0;
    if (opts) {
        if ((0, _DryFunctions.isString)(opts)) {
            html = opts;
        } else {
            if (opts.html) {
                html = opts.html;
            } else if (opts.txt) {
                html = '<span>' + opts.txt + '</span>';
            }
        }
    }
    // console.log('makeNode: html: ', html);
    var domel = void 0;
    var d = document.createElement('div');
    d.innerHTML = html;
    try {
        if (opts.wrapDiv) {
            domel = d;
        } else {
            domel = d.firstElementChild;
        }
    } catch (e) {
        console.error('DomHelper.makeNode error: ', e, html);
    }
    return domel;
}

function makeNodesByTagname(nList) {
    var ret = [];
    nList = nList || [];
    nList.forEach(function (nn) {
        var e = document.createElement(nn);
        ret.push(e);
    });
    return ret;
}

function FreezeBody() {
    var bodyScrollTop = void 0;
    return {
        freezeBody: function freezeBody() {
            bodyScrollTop = document.body.scrollTop || document.documentElement.scrollTop || 0;
            document.body.classList.add('izFrozen');
        },
        unfreezeBody: function unfreezeBody() {
            document.body.classList.remove('izFrozen');
            if (bodyScrollTop || bodyScrollTop === 0) {
                document.body.scrollTop = Math.abs(bodyScrollTop);
                document.documentElement.scrollTop = Math.abs(bodyScrollTop);
                bodyScrollTop = void 0;
            }
        }
    };
}

module.exports = {
    FreezeBody: FreezeBody(),
    makeNode: makeNode,
    makeNodesByTagname: makeNodesByTagname
};

},{"./DryFunctions.es6":3}],3:[function(require,module,exports){
/*global console, module */
/*jshint devel:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLocalhost = isLocalhost;
exports.luhnCheck = luhnCheck;
exports.isArray = isArray;
exports.isString = isString;
exports.isBool = isBool;
exports.argsToArray = argsToArray;
exports.bindAllFuncs = bindAllFuncs;
var LocalhostHosts = ['localhost', 'ormsby', 'chriso'];
function isLocalhost() {
    var ret = false;
    LocalhostHosts.forEach(function (s) {
        if (window.location.hostname.match(s)) {
            ret = true;
        }
    });
    return ret;
}

var emailRegx = exports.emailRegx = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

function luhnCheck(val) {
    /*jshint -W016 */
    var luhnArr = [[0, 2, 4, 6, 8, 1, 3, 5, 7, 9], [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]];
    var sum = 0;
    val.replace(/\D+/g, "").replace(/[\d]/g, function (c, p, o) {
        sum += luhnArr[o.length - p & 1][parseInt(c, 10)];
    });
    return sum % 10 === 0 && sum > 0;
}

function isArray(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
}
function isString(a) {
    return Object.prototype.toString.call(a) === '[object String]';
}

function isBool(b) {
    return b === true || b === false;
}

function argsToArray(a) {
    return Array.prototype.slice.call(a);
}

function bindAllFuncs(obj, cfg) {
    var verbose = cfg && cfg.verbose;
    var name = cfg && cfg.name;
    for (var att in obj) {
        if (obj.hasOwnProperty(att) && typeof obj[att] === 'function') {
            if (isLocalhost() && verbose) {
                console.log('binding func ' + att + ' to:', name ? name : obj);
            }
            obj[att] = obj[att].bind(obj);
        }
    }
}

module.exports = {
    isLocalhost: isLocalhost,
    emailRegx: emailRegx,
    luhnCheck: luhnCheck,
    isArray: isArray,
    isBool: isBool,
    isString: isString,
    argsToArray: argsToArray,
    bindAllFuncs: bindAllFuncs
};

},{}],4:[function(require,module,exports){
/* global console, ga */
/*jshint unused:true, eqnull:true, curly:true */
/*jshint strict:true */
/*jshint browser: true, browserify: true */
/*jshint -W030, -W069 */
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (cfg) {
    var MY_GA = void 0,
        debugMode = false,
        useEcommerce = true;

    if (debugMode) {
        console.log('%cGoogleAnalytics is in DEBUG MODE! (bad in prod!) vGAMHes6', 'background:#B50F0F;color:white;font-size:1.6em;padding:1em');
    }

    if (cfg) {
        if (cfg.debug) {
            debugMode = true;
        }
        if (cfg.useEcommerce) {
            useEcommerce = true;
        }
    }
    // always turn off debugMode if not a dev-host
    if (!(0, _Browser.isDevHost)()) {
        debugMode = false;
    }
    if (debugMode) {
        MY_GA = function MY_GA() {
            var argMod = [];
            Array.prototype.slice.call(arguments).forEach(function (arg) {
                if (typeof arg === 'string') {
                    arg = arg.replace(/'/g, '');
                    argMod.push("'" + arg + "'");
                } else if (typeof arg === 'number') {
                    argMod.push("'" + arg + "'");
                } else if ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) === 'object' && (arg.hasOwnProperty('page') || arg.hasOwnProperty('location'))) {
                    var subObj = [];
                    Object.keys(arg).forEach(function (k) {
                        subObj.push("'" + k + "':'" + arg[k] + "'");
                    });
                    argMod.push('{' + subObj.join(',') + '}');
                }
            });
            console.log('simulated GA event: ga(' + argMod.join(', ') + ')');
        };
    } else {
        // NOT debugMode
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();
            a = s.createElement(o), m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        ga('create', gaProfile, 'auto', { 'allowLinker': true });
        ga('require', 'displayfeatures');
        if (useEcommerce) {
            ga('require', 'ecommerce');
        }
        ga('require', 'linker');
        ga('linker:autoLink', ['m2.manhunt.net'], ['manhuntdaily.com'], ['manhuntdiario.com'], ['manhuntagora.com'], ['manhuntcares.com'], ['manhunt.porn'], ['manhuntnet.tumblr.com']);
        MY_GA = function MY_GA() {
            window.ga.apply(window, arguments);
        };
    }
    return MY_GA;
};

var _Browser = require("./Browser.es6");

var gaProfile = 'UA-5700973-24';

},{"./Browser.es6":1}],5:[function(require,module,exports){
/*jshint devel:true, browser:true */
/*jshint -W097 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ensureGrecap = ensureGrecap;
exports.resetGrecaptcha = resetGrecaptcha;
exports.setupGrecaptcha = setupGrecaptcha;
var ysot = 'You should override this';
var gRecap = {};
gRecap.renderedGrecap = false;
gRecap.rendGrecapId = void 0;
gRecap.rendGrecapCtr = 0;

var globRecapSuccName = 'grecapSuccCbL8rx';
if (!window[globRecapSuccName]) {
    window[globRecapSuccName] = function () {
        console.log('Default recaptcha success callback. ' + ysot);
    };
}

var globRecapLoadSuccName = 'lsesrcCbFunctL11xg';
if (!window[globRecapLoadSuccName]) {
    window[globRecapLoadSuccName] = function () {
        console.error('Default recaptcha LOADED callback. ' + ysot);
    };
}
var msk = '6LfhdzAUAAAAADDJTS7Mpd8cW3eN-4chJqGDoVN7';
function ensureGrecap(_ref) {
    var mainEl = _ref.mainEl,
        resetEl = _ref.resetEl,
        succCb = _ref.succCb,
        resetCb = _ref.resetCb,
        lang = _ref.lang;

    if (window.grecaptcha && window.grecaptcha.render && !gRecap.renderedGrecap) {
        lang = lang || 'en';
        if (typeof resetCb !== 'function') {
            resetCb = function resetCb() {
                console.log('Default recaptcha RESET callback. ' + ysot);
            };
        }
        if (succCb) {
            window[globRecapSuccName] = succCb;
        }
        window.grecaptcha.render('g-recaptcha-wr', {
            'sitekey': msk,
            'hl': lang,
            'callback': globRecapSuccName
        });
        mainEl = mainEl || document.getElementById('g-recaptcha-wr');
        resetEl = resetEl || document.getElementById('g-recaptcha-reset');
        if (mainEl && mainEl.classList) {
            mainEl.classList.remove('hidden');
            if (resetEl && resetEl.addEventListener) {
                resetEl.classList.remove('hidden');
                resetEl.addEventListener('click', function () {
                    resetCb();
                    if (window.grecaptcha) {
                        window.grecaptcha.reset();
                    }
                });
            }
            gRecap.renderedGrecap = true;
        }
    } else {
        if (gRecap.rendGrecapCtr++ < 10) {
            gRecap.rendGrecapId = setTimeout(function () {
                ensureGrecap({
                    mainEl: mainEl, resetEl: resetEl, succCb: succCb, resetCb: resetCb, lang: lang
                });
            }, 700);
        } else {
            console.error('google recaptcha failed to load logshar26');
        }
    }
}
function resetGrecaptcha() {
    gRecap = {};
    gRecap.renderedGrecap = false;
    gRecap.rendGrecapId = void 0;
    gRecap.rendGrecapCtr = 0;
}
function setupGrecaptcha(succCb) {
    // console.log('setupGrecaptcha called!');
    if (succCb && typeof succCb === 'function') {
        window[globRecapLoadSuccName] = succCb;
    }
    var s = document.createElement('script');
    s.src = 'https://www.google.com/recaptcha/api.js?onload=' + globRecapLoadSuccName + '&render=explicit';
    s.setAttribute('async', true);
    s.setAttribute('defer', true);
    document.body.appendChild(s);
}

},{}],6:[function(require,module,exports){
/* global module */
/*jshint unused:true, eqnull:true, curly:true */
/*jshint strict:true */
/*jshint browser: true, browserify: true */
/*jshint -W097 */
"use strict";

/**
 * MicroEvent - to make any js object an event emitter (server or browser)
 *
 * - pure javascript - server compatible, browser compatible
 * - doesn't rely on the browser dom
 * - super simple - you get it immediately, no mystery, no magic involved
 *
 * - create a MicroEventDebug with goodies to debug
 *   - make it safer to use
 */

var MicroEvent	= function(){};
MicroEvent.prototype	= {
    bind	: function(event, fct){
        this._events = this._events || {};
        this._events[event] = this._events[event]	|| [];
        this._events[event].push(fct);
    },
    unbind	: function(event, fct){
        this._events = this._events || {};
        if( event in this._events === false  )	return;
        this._events[event].splice(this._events[event].indexOf(fct), 1);
    },
    trigger	: function(event /* , args... */){
        this._events = this._events || {};
        if( event in this._events === false  )	{ return; }
        for(var i = 0; i < this._events[event].length; i++){
            this._events[event][i].apply(this, Array.prototype.slice.call(arguments, 1));
        }
    }
};

/**
 * mixin will delegate all MicroEvent.js function in the destination object
 *
 * - require('MicroEvent').mixin(Foobar) will make Foobar able to use MicroEvent
 *
 * @param {Object} the object which will support MicroEvent
 */
MicroEvent.mixin	= function(destObject) {
    var props	= ['bind', 'unbind', 'trigger'];
    for(var i = 0; i < props.length; i ++){
        if( typeof destObject === 'function' ){
            destObject.prototype[props[i]]	= MicroEvent.prototype[props[i]].bind(destObject);
        }else{
            destObject[props[i]] = MicroEvent.prototype[props[i]].bind(destObject);
        }
    }
    return destObject;
};

// export in common js
if( typeof module !== "undefined" && ('exports' in module)){
    module.exports	= MicroEvent;
}
},{}],7:[function(require,module,exports){
(function (global){(function (){
/* global module, global, define, console */
/*jshint unused:true, eqnull:true, curly:true */
/*jshint strict:true */
/*jshint -W097 */
"use strict";

(function (name, context, definition) {
    if (typeof module !== 'undefined' && module.exports) {
        // commonjs / browserify module
        module.exports = definition();
    } else if (typeof define === 'function' && define.amd) {
        // requirejs / define.amd module
        define(name, definition);
    } else {
        // neither module framework, attach object as a global
        context[name] = definition();
    }
}('MhMatchMediaQuery', typeof window === 'object' ? window : global, function () {

    var mhMQ = {
        initialize: function () {

        },
        matches: function (argObj) {
            var retVal = 'screen',
                that = this,
                debug = false;
            if (argObj) {
                if (typeof argObj === 'string') {
                    if (argObj.match(/\(/)) {
                        retVal += ' and ' + argObj;
                    } else {
                        retVal += ' and (' + argObj + ')';
                    }
                } else {
                    if (argObj.all) {
                        retVal = 'all';
                    }
                    if (argObj.debug) {
                        debug = true;
                    }
                    Array.prototype.forEach.call(Object.keys(argObj), function (k) {
                        switch (k) {
                            case 'screen':
                            case 'all':
                            case 'debug':
                                break;
                            case 'minWidth':
                                retVal += ' and (min-width: ' + that.pxIze(argObj[k]) + ')' ;
                                break;
                            case 'maxWidth':
                                retVal += ' and (max-width: ' + that.pxIze(argObj[k]) + ')' ;
                                break;
                            case 'minHeight':
                                retVal += ' and (min-height: ' + that.pxIze(argObj[k]) + ')' ;
                                break;
                            case 'maxheight':
                                retVal += ' and (max-height: ' + that.pxIze(argObj[k]) + ')' ;
                                break;
                            default:
                                retVal += ' and (' + k + ': ' + that.pxIze(argObj[k]) + ')' ;
                        }
                    });
                }
            } else {
                throw "matches() function requires an argument";
            }
            if (debug) {
                console.log('MhMatchMediaQuery.matches: arg: ', argObj);
                console.log('Generated query; ', retVal);
            }

            try {
                var q = window.matchMedia(retVal);
                if (debug) {
                    console.log('q: ', q);
                }
                return q.matches;
            } catch (e) {
                return false;
            }
        },
        pxIze: function (a) {
            return (a === parseInt(a, 10)) ? a + 'px' : a;
        },
        isSmallPhone: function () {
            return this.matches({
                maxWidth: 320
            });
        },
        isPhone: function () {
            return this.matches({
                minWidth: 320,
                maxWidth: 640
            });
        },
        isAnyPhone: function () {
            return this.matches({
                maxWidth: 640
            });
        },
        isPhablet: function () {
            return this.matches({
                minWidth: 401,
                maxWidth: 736
            });
        },
        isTablet: function () {
            return this.matches({
                minWidth: 600,
                maxWidth: 1024
            });
        },
        isAllMobile: function () {
            return this.matches({
                minWidth: 200,
                maxWidth: 1024
            });
        },
        isMax800: function () {
            return this.matches({
                maxWidth: 800
            });
        },
        isDesktop: function () {
            return this.matches({
                minWidth: 1025
            });
        },
        isDesktopHuge: function () {
            return this.matches({
                minWidth: 1400
            });
        },
        isDesktopMassive: function () {
            return this.matches({
                minWidth: 2000
            });
        }
    };
    Object.keys(mhMQ).forEach(function (k) {
        if (mhMQ[k] && typeof mhMQ[k] === 'function') {
            mhMQ[k] = mhMQ[k].bind(mhMQ);
        }
    });
    mhMQ.initialize();
    return mhMQ;
}));
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var runRe = function runRe(re, subject) {
    var m = void 0,
        ret = [];
    do {
        m = re.exec(subject);
        if (m) ret.push(m);
    } while (m);
    return ret;
};

var reUpperCase = /[A-Z]/g;
var reLowerCase = /[a-z]/g;
var reDigits = /[0-9]/g;
var reSymbols = /[-_@!#$%^&*()}{|'"?/>.<,~`[=\]]/g;
var reChars = /[a-zA-Z]/g;
var reRepeatChars = /(.)\1/g;
var reRepeat3Chars = /(.)\1{2}/g;
var reRepeat4Chars = /(.)\1{3}/g;
var reConsecCharU = /[A-Z]{2}/g;
var reConsecCharU3 = /[A-Z]{3}/g;
var reConsecCharU4 = /[A-Z]{4}/g;
var reConsecCharL = /[a-z]{2}/g;
var reConsecCharL3 = /[a-z]{3}/g;
var reConsecCharL4 = /[a-z]{4}/g;
var reConsecNum = /[0-9]{2}/g;
var reConsecNum3 = /[0-9]{3}/g;
var reConsecNum4 = /[0-9]{4}/g;
var reConsecNum5 = /[0-9]{5}/g;
var reConsecNum6 = /[0-9]{6}/g;
var _re_upperCase = function _re_upperCase(s) {
    return runRe(reUpperCase, s);
};
var _re_lowerCase = function _re_lowerCase(s) {
    return runRe(reLowerCase, s);
};
var _re_numbers = function _re_numbers(s) {
    return runRe(reDigits, s);
};
var _re_symbols = function _re_symbols(s) {
    return runRe(reSymbols, s);
};

var _sc_numChars = function _sc_numChars(s) {
    return s.length * 4;
};
var _sc_upperCaseChars = function _sc_upperCaseChars(s) {
    return _re_upperCase(s).length ? (s.length - _re_upperCase(s).length) * 2 : 0;
};
var _sc_lowerCaseChars = function _sc_lowerCaseChars(s) {
    return _re_lowerCase(s).length ? (s.length - _re_lowerCase(s).length) * 2 : 0;
};
var _sc_numbers = function _sc_numbers(s) {
    return _re_numbers(s).length * 4;
};
var _sc_symbols = function _sc_symbols(s) {
    return _re_symbols(s).length * 6;
};
var _sc_innerNumOrSym = function _sc_innerNumOrSym(s) {
    return innerNumOrSymbs(s).length * 2;
};

var _sc_lettersOnly = function _sc_lettersOnly(s) {
    return runRe(reChars, s).length === s.length ? s.length * -1 : 0;
};
var _sc_digitsOnly = function _sc_digitsOnly(s) {
    return _re_numbers(s).length === s.length ? s.length * -1 : 0;
};

var _sc_repeatChars2 = function _sc_repeatChars2(s) {
    return runRe(reRepeatChars, s).length * -2;
};
var _sc_repeatChars3 = function _sc_repeatChars3(s) {
    return runRe(reRepeat3Chars, s).length * -3;
};
var _sc_repeatChars4 = function _sc_repeatChars4(s) {
    return runRe(reRepeat4Chars, s).length * -4;
};
var _sc_consecUC = function _sc_consecUC(s) {
    return runRe(reConsecCharU, s).length * -2;
};
var _sc_consecUC3 = function _sc_consecUC3(s) {
    return runRe(reConsecCharU3, s).length * -3;
};
var _sc_consecUC4 = function _sc_consecUC4(s) {
    return runRe(reConsecCharU4, s).length * -4;
};
var _sc_consecLC2 = function _sc_consecLC2(s) {
    return runRe(reConsecCharL, s).length * -2;
};
var _sc_consecLC3 = function _sc_consecLC3(s) {
    return runRe(reConsecCharL3, s).length * -3;
};
var _sc_consecLC4 = function _sc_consecLC4(s) {
    return runRe(reConsecCharL4, s).length * -4;
};
var _sc_consecDIG2 = function _sc_consecDIG2(s) {
    return runRe(reConsecNum, s).length ? (runRe(reConsecNum, s).length + 1) * -2 : 0;
};
var _sc_consecDIG3 = function _sc_consecDIG3(s) {
    return runRe(reConsecNum3, s).length ? (runRe(reConsecNum3, s).length + 1) * -3 : 0;
};
var _sc_consecDIG4 = function _sc_consecDIG4(s) {
    return runRe(reConsecNum4, s).length ? (runRe(reConsecNum4, s).length + 1) * -4 : 0;
};
var _sc_consecDIG5 = function _sc_consecDIG5(s) {
    return runRe(reConsecNum5, s).length ? (runRe(reConsecNum5, s).length + 1) * -5 : 0;
};
var _sc_consecDIG6 = function _sc_consecDIG6(s) {
    return runRe(reConsecNum6, s).length ? (runRe(reConsecNum6, s).length + 1) * -6 : 0;
};

var innerNumOrSymbs = function innerNumOrSymbs(s) {
    var s2 = s.substr(1, s.length - 2);
    return _re_numbers(s2).concat(_re_symbols(s2));
};

var requirementsPass = exports.requirementsPass = function requirementsPass(s) {
    // console.log('requirementsPass called: ', s);
    var len = s.length >= 8;
    var u = _re_upperCase(s).length;
    var l = _re_lowerCase(s).length;
    var d = _re_numbers(s).length;
    var y = _re_symbols(s).length;
    // console.log('len, u, l, d, y', len, u, l, d, y);
    if (!u) throw 'upper';
    if (!l) throw 'lower';
    if (!d) throw 'number';
    if (!y) throw 'symbol';
    if (!len) throw 'length';
    // console.log('requirementsPass about to pass...');
    return true;
};

var strengthScore = exports.strengthScore = function strengthScore(s) {
    var posSc = 0;
    var negSc = 0;
    var retVal = void 0;

    var chars_score = _sc_numChars(s);
    posSc += chars_score;

    var upper = _sc_upperCaseChars(s);
    posSc += upper;

    var lower = _sc_lowerCaseChars(s);
    posSc += lower;

    var digi = _sc_numbers(s);
    posSc += digi;

    var symb = _sc_symbols(s);
    posSc += symb;

    var midNumsSymbs = _sc_innerNumOrSym(s);
    posSc += midNumsSymbs;

    var onlyChars = _sc_lettersOnly(s);
    negSc += onlyChars;

    var _onlyNums = _sc_digitsOnly(s);
    negSc += _onlyNums;

    var _repeatedChars = _sc_repeatChars2(s);
    negSc += _repeatedChars;

    var _repeatedChars3 = _sc_repeatChars3(s);
    negSc += _repeatedChars3;

    var _repeatedChars4 = _sc_repeatChars4(s);
    negSc += _repeatedChars4;

    var _consecUc2 = _sc_consecUC(s);
    negSc += _consecUc2;

    var _consecUc3 = _sc_consecUC3(s);
    negSc += _consecUc3;

    var _consecUc4 = _sc_consecUC4(s);
    negSc += _consecUc4;

    var _consecLc2 = _sc_consecLC2(s);
    negSc += _consecLc2;

    var _consecLc3 = _sc_consecLC3(s);
    negSc += _consecLc3;

    var _consecLc4 = _sc_consecLC4(s);
    negSc += _consecLc4;

    var _consecDig2 = _sc_consecDIG2(s);
    negSc += _consecDig2;

    var _consecDig3 = _sc_consecDIG3(s);
    negSc += _consecDig3;

    var _consecDig4 = _sc_consecDIG4(s);
    negSc += _consecDig4;

    var _consecDig5 = _sc_consecDIG5(s);
    negSc += _consecDig5;

    var _consecDig6 = _sc_consecDIG6(s);
    negSc += _consecDig6;

    retVal = posSc + negSc;

    try {
        requirementsPass(s);
    } catch (e) {
        retVal = retVal >= 100 ? 90 : retVal;
    } // eslint-disable-line
    return retVal;
};

},{}],9:[function(require,module,exports){
/*global module */
/*jshint strict:true */
/*jshint browser: true, devel: true */
/*jshint -W097 */
"use strict";
var CH = {};


CH.getCookies = function () {
    var allCookies = document.cookie.split(';');
    var ret = {};
    allCookies.forEach(function (c) {
        var a = c.split('=');
        var o;
        /*
         o = o || {};
         o[a[0].trim()] = a[1].trim();
         */
        try {
            ret[a[0].trim()] = a[1].trim();
        } catch (e) {}
    });
    return ret;
};
CH.getCookie = function (key) {
    var cks = CH.getCookies();
    return (cks && cks[key]) ? cks[key] : void 0;
};
CH.getAllNames = function () {
    var cks = CH.getCookies();
    return cks && Object.keys(cks);
};

module.exports = CH;

},{}],10:[function(require,module,exports){
/*global easeOutCubic */
/*jshint esversion: 6, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';

var BindToScroll = require('./BindToScrollEventHelper.es6');

var reqAnimFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

var bind2ScrHelper = new BindToScroll();

var threshPx = 200;
var aboveThrFunc = function aboveThrFunc() {
    console.log('default AOSPH.aboveThresholdFunction called.');
};
var belowThrFunc = function belowThrFunc() {
    console.log('default AOSPH.belowThresholdFunction called.');
};

var AOSPH = function AOSPH(options) {

    // https://gist.github.com/paulmillr/3118943
    var lastScrollY = 0;
    var ticking = false;

    var scrTopEl = void 0;
    var capturedScrTopEl = false;

    function captureScrTopEl() {
        if (document.documentElement && document.documentElement.scrollTop > 0) {
            scrTopEl = document.documentElement;
        } else if (document.body && document.body.scrollTop > 0) {
            scrTopEl = document.body;
        }
        if (scrTopEl) {
            capturedScrTopEl = true;
        }
        return capturedScrTopEl;
    }

    var update = function update() {
        if (!capturedScrTopEl) {
            captureScrTopEl();
        }
        if (!capturedScrTopEl) {
            console.error('update function: COULD NOT FIND AN ELEMENT THAT HAS THE scrollTop attribute');
            return;
        }
        if (scrTopEl.scrollTop > threshPx) {
            document.body.trigger('scrolledDown');
            belowThrFunc();
        } else {
            document.body.trigger('scrolledUp');
            aboveThrFunc();
        }
        ticking = false;
    };

    var requestTick = function requestTick() {
        if (!ticking) {
            reqAnimFrame(update);
            ticking = true;
        } else {
            console.log('request tick function - ticking===true');
        }
    };

    var onScroll = function onScroll() {
        lastScrollY = window.scrollY;
        requestTick();
    };
    bind2ScrHelper.bindToScroll(onScroll);

    function initialize(opts) {
        if (opts) {
            if (opts.threshold) {
                threshPx = parseInt(opts.threshold, 10);
            }
            if (opts.aboveCallback) {
                aboveThrFunc = opts.aboveCallback;
            }
            if (opts.belowCallback) {
                belowThrFunc = opts.belowCallback;
            }
        }
    }
    initialize(options);
};
AOSPH.prototype.setThreshold = function (thr) {
    threshPx = parseInt(thr, 10);
};
AOSPH.prototype.setAboveCallback = function (f) {
    aboveThrFunc = f;
};
AOSPH.prototype.setBelowCallback = function (f) {
    belowThrFunc = f;
};
module.exports = AOSPH;

},{"./BindToScrollEventHelper.es6":12}],11:[function(require,module,exports){
/*jshint esversion: 6, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';

var bodyEl = document.querySelector('body');
var bindToScr = function bindToScr(f) {
    window.addEventListener('mousewheel', f);
    bodyEl.addEventListener('touchstart', f);
};
var unbindScr = function unbindScr(f) {
    window.removeEventListener('mousewheel', f);
    bodyEl.removeEventListener('touchstart', f);
};
var BTMTEH = function BTMTEH(options) {
    function init(opts) {
        if (opts && opts.callback) {
            bindToScr(opts.callback);
        }
    }
    init(options);
};
BTMTEH.prototype.bindToMouseTouch = function (f) {
    bindToScr(f);
};
BTMTEH.prototype.unbindMousetouch = function (f) {
    unbindScr(f);
};
module.exports = BTMTEH;

},{}],12:[function(require,module,exports){
/*jshint esversion: 6, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';

var bodyEl = document.querySelector('body');
var bindToScr = function bindToScr(f) {
    window.addEventListener('scroll', f);
    bodyEl.addEventListener('DOMMouseScroll', f);
};
var unbindScr = function unbindScr(f) {
    window.removeEventListener('scroll', f);
    bodyEl.removeEventListener('DOMMouseScroll', f);
};
var BTSEH = function BTSEH(options) {
    function init(opts) {
        if (opts && opts.callback) {
            bindToScr(opts.callback);
        }
    }
    init(options);
};
BTSEH.prototype.bindToScroll = function (f) {
    bindToScr(f);
};
BTSEH.prototype.unbindScroll = function (f) {
    unbindScr(f);
};
module.exports = BTSEH;

},{}],13:[function(require,module,exports){
/*global easeOutCubic */
/*jshint esversion: 6, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';

var BindToMouseTouch = require('./BindToMouseTouchEventHelper.es6');
/*
 options: el4clickBind (optional.  alternately, use this.bindEl)
 */
var bind2mseTch = new BindToMouseTouch();
var currentScrollPosition = void 0;
var iteration = void 0;
var start = false;

var reqAnimFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

function bindEl(clickEl) {
    clickEl.addEventListener("click", animateToTopOfPage, false);
}
function unbindEl(clickEl) {
    clickEl.removeEventListener("click", animateToTopOfPage);
}
function animateToTopOfPage() {
    // kick of the animation to scroll your window back to the top
    /*jshint -W016 */
    currentScrollPosition = getScrollPosition();
    start ^= true;
    iteration = 0;
}

function stopEverything() {
    // stop the animation and reset start and iteration
    start = false;
}

function getScrollPosition() {
    // cross-browser (minus Opera) way of getting the current scroll position
    if (document.documentElement.scrollTop === 0) {
        return document.body.scrollTop;
    } else {
        return document.documentElement.scrollTop;
    }
}

function animationLoop() {
    // kicks into high gear only when the start variable is true
    // start is true when you click on the up arrow
    if (start) {
        // where the magic happens
        window.scrollTo(0, easeOutCubic(iteration, currentScrollPosition, -currentScrollPosition, 50));

        iteration++;

        // once you reach the top of the document, stop the scrolling
        if (getScrollPosition() <= 0) {
            stopEverything();
        }
    }
    reqAnimFrame(animationLoop);
}

var STTW = function STTW(options) {
    function initialize(opts) {
        if (opts) {
            if (opts.el4clickBind) {
                bindEl(opts.el4clickBind);
            }
        }
        bind2mseTch.bindToMouseTouch(stopEverything);
        animationLoop();
    }
    initialize(options);
};
STTW.prototype.bindEl = bindEl;
STTW.prototype.unbindEl = unbindEl;

module.exports = STTW;

},{"./BindToMouseTouchEventHelper.es6":11}],14:[function(require,module,exports){
/*jshint devel:true, browser:true */
/*jshint -W097 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sessionPlanInfo = undefined;
exports.getV5ContentModal = getV5ContentModal;
exports.throwModal = throwModal;
exports.showLoadingCurtain = showLoadingCurtain;
exports.hideLoadingCurtain = hideLoadingCurtain;
exports.displGenFb = displGenFb;
exports.hijackFooterLinks = hijackFooterLinks;
exports.setupLegalLinks = setupLegalLinks;

var _DOM = require('../../common/js/modules/DOM.es6');

function gtOkB() {
    // this is non-minified version: minified version is directly below
    var d = document.createElement('div');
    var b1 = document.createElement('button');
    b1.setAttribute('data-hook', 'logpg-btn-cancel');
    b1.textContent = document.getElementById('oktxt').getAttribute('data-val');
    b1.setAttribute('style', 'margin-right: 0.5em;');
    b1.className = 'm5 hvr';
    b1.setAttribute('style', 'font-size:1em;');
    d.appendChild(b1);
    d.setAttribute('style', 'margin-top: 1em;text-align: right;');
    return d;
}
function getV5ContentModal(opts) {
    // this is non-minified version: minified version is directly below
    var title = '',
        mainContent,
        closeFunc,
        addClass,
        closeCallback = function closeCallback() {};
    if (opts) {
        if (opts.title) {
            title = opts.title;
        }
        if (opts.closeCallback) {
            closeCallback = opts.closeCallback;
        }
        closeFunc = function closeFunc() {
            closeCallback();
            parentEl.remove();
        };
        if (opts.mainContent) {
            mainContent = opts.mainContent;
        }
        if (opts.addClass) {
            addClass = opts.addClass;
        }
    }
    var curt, parentEl, closeX;
    curt = document.createElement('div');
    curt.className = 'v5cmwCurtain contMod';
    parentEl = curt;

    closeX = document.createElement('div');
    closeX.className = 'v5cmwCloseX';
    closeX.addEventListener('click', closeFunc);

    var modalEl = document.createElement('div');
    modalEl.className = 'v5contentModalStd';
    if (addClass) {
        modalEl.className = 'v5contentModalStd ' + addClass;
    }
    var headr = document.createElement('div');
    headr.className = 'v5contHeader';
    var titWrp = document.createElement('div');
    titWrp.className = 'v5cTitleWrap';
    var tit = document.createElement('div');
    tit.className = 'v5cTitle';
    if (title) {
        tit.textContent = title;
    }
    titWrp.appendChild(tit);
    headr.appendChild(titWrp);

    if (closeX) {
        headr.appendChild(closeX);
    }
    modalEl.appendChild(headr);

    var contEl = document.createElement('div');
    contEl.className = 'v5contBody';
    if (mainContent) {
        contEl.appendChild(mainContent);
    }
    modalEl.appendChild(contEl);

    var butts = gtOkB();
    contEl.appendChild(butts);
    butts.querySelector('button').addEventListener('click', function () {
        parentEl.remove();
        closeCallback();
    });

    parentEl.appendChild(modalEl);
    parentEl.addEventListener('click', closeFunc);
    modalEl.addEventListener('click', function (e) {
        e.stopPropagation();
    });
    return parentEl;
}
function throwModal(opts) {
    var d = document.createElement('div');
    d.innerHTML = opts.html;
    var cmOpts = {
        title: opts.title,
        mainContent: d
    };
    if (opts.addClass) {
        cmOpts.addClass = opts.addClass;
    }
    if (opts.closeCallback) {
        cmOpts.closeCallback = opts.closeCallback;
    }
    var parEl = getV5ContentModal(cmOpts);
    document.body.appendChild(parEl);
}

function showLoadingCurtain() {
    var t = document.querySelector('[data-template-name=animated_loading_nine_grid]');
    var d = document.createElement('div');
    d.id = 'shwldgcubeanim';
    d.className = 'loadingIcon';
    d.innerHTML = t.innerHTML;
    document.body.appendChild(d);
}
function hideLoadingCurtain() {
    var el = document.querySelector('#shwldgcubeanim');
    if (el && el.remove) {
        el.remove();
    }
}
function displGenFb() {
    var par = document.querySelector('#rapidreg .formElems');
    if (par) {
        var d = document.createElement('div');
        d.className = 'fullFb';
        d.innerHTML = '<div><p>There has been an error.</p><p>Please reload the page and try again.</p><p>If the problem persists, please contact Customer Service at 1-866-424-9999</p></div>';
        par.appendChild(d);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'm5';
        b.innerHTML = 'OK';
        b.onclick = function () {
            d.remove();
        };
        d.appendChild(b);
    } else {
        console.error('could not find #rapidreg .formElems in displGenFb');
    }
}
function hijackFooterLinks() {
    var langDiv = document.querySelector('#v5-external-footer-langs');
    var langLinks = void 0;
    if (langDiv) {
        langLinks = langDiv.querySelectorAll('a.v5-external-footer-lang');
        if (langLinks) {
            langLinks.forEach(function (a) {
                var chgUrl = a.getAttribute('href');
                a.onclick = function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    var url = chgUrl + '?' + 'backTo=' + encodeURIComponent(document.location.pathname + document.location.search);
                    // console.log('url: ', url);
                    window.location.href = url;
                };
            });
        } else {
            console.error('v5rapidPurch: 222');
        }
    } else {
        console.error('v5rapidPurch: 225');
    }
}
// SET UP PRIVACY POLICY AND TOS LINKS & FUNCTIONALITY
function setupLegalLinks() {
    var legalLinks = document.querySelectorAll('#privpolfoot, [data-hook=showprivpolicy], [data-hook=showtos]');
    legalLinks.forEach(function (el) {
        el.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            var request = new XMLHttpRequest();
            request.open('POST', el.getAttribute('data-url'));
            request.onload = function () {
                if (request.status === 200) {
                    throwModal({
                        html: request.responseText,
                        title: el.getAttribute('data-title')
                    });
                } else {
                    console.error('There was an error fetching the Privacy Policy!');
                }
            };
            request.onerror = function () {
                console.error('There was an error fetching the Privacy Policy!');
            };
            request.send();
        });
    });
    var csLink = document.getElementById('custsvcfoot');
    if (csLink) {
        csLink.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            var title = csLink.getAttribute('data-title'),
                html = document.getElementById('customerServiceModalContent').innerHTML.trim();
            throwModal({
                html: html,
                title: title,
                addClass: 'narrow'
            });
        });
    }
}

var sessionPlanInfo = exports.sessionPlanInfo = function () {
    var o = {
        set: function set(data) {
            if (data) {
                if (data.planName) {
                    sessionStorage.setItem('pn', data.planName);
                }
                if (data.salePrice) {
                    sessionStorage.setItem('sp', data.salePrice);
                }
                if (data.origPrice) {
                    sessionStorage.setItem('op', data.origPrice);
                }
            }
        },
        get: function get() {
            return {
                planName: sessionStorage.getItem('pn'),
                origPrice: sessionStorage.getItem('op'),
                salePrice: sessionStorage.getItem('sp')
            };
        },
        clear: function clear() {
            sessionStorage.removeItem('pn');
            sessionStorage.removeItem('op');
            sessionStorage.removeItem('sp');
        }
    };
    for (var att in o) {
        if (typeof o[att] === 'function') {
            // console.log(`sessionPlanInfo -> binding func ${att}.`);
            o[att] = o[att].bind(o);
        }
    }
    return o;
}();

},{"../../common/js/modules/DOM.es6":2}],15:[function(require,module,exports){
/*global grecaptcha */
/*eslint no-empty:0 */
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _loginSharedEs = require('./loginShared.es6.js');

var _DryFunctions = require('../../common/js/modules/DryFunctions.es6');

var _loginShared = require('./loginShared.es6');

var _GoogleRecaptchaHelper = require('../../common/js/modules/GoogleRecaptchaHelper.es6');

var _Browser = require('../../common/js/modules/Browser.es6');

var _passwordValidator = require('../../common/js/util/passwordValidator.es6');

var _GoogleAnalyticsMH = require('../../common/js/modules/GoogleAnalyticsMH.es6');

var _GoogleAnalyticsMH2 = _interopRequireDefault(_GoogleAnalyticsMH);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollToTopHelper = require('../../common/js/widgets/ScrollToTopHelper.es6');
var CookieHelper = require('../../common/js/util/util_cookies');

var ActOnScrPosHelper = require('../../common/js/widgets/ActOnScrollPosHelper.es6');
var actOnScrPos = new ActOnScrPosHelper();

var GOOGLE_ANAL = (0, _GoogleAnalyticsMH2.default)();

var L = (0, _Browser.isDevHost)();

var mhMediaQuery = require('../../common/js/util/mhMatchMediaQuery');

var v5login = function v5login() {
    var BLANKVALOK = true;

    (0, _Browser.ensureWithPolyfill)('promise');

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }

    /** Kicks off async call to browser's geolocation API.
     * When complete, window.navLatLonData will be set globally.
     * @returns {true} - no meaningful return from this call.
     */
    function tryGetLocData() {
        window.navLatLonData = void 0;
        (0, _Browser.requestLatLonBrowserData)().then(function (pos) {
            window.navLatLonData = pos;
            // console.log('window.navLatLonData has been set using navigator.geolocation.getCurrentPosition():',pos);
        }, function () {
            console.error('could not get info from navigator.geolocation.getCurrentPosition()');
        });
    }

    var privPolLink = document.getElementById('privpolfoot');
    privPolLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var request = new XMLHttpRequest();
        request.open('POST', privPolLink.getAttribute('data-url'));
        request.onload = function () {
            // console.log('onload: ', request.responseText);
            if (request.status === 200) {
                (0, _loginShared.throwModal)({
                    html: request.responseText,
                    title: privPolLink.getAttribute('data-title')
                });
            } else {
                console.error('There was an error fetching the Privacy Policy!');
            }
        };
        request.onerror = function () {
            console.error('There was an error fetching the Privacy Policy!');
        };
        request.send();
    });

    var tosLink = document.getElementById('tosfoot');
    tosLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var request = new XMLHttpRequest();
        request.open('POST', tosLink.getAttribute('data-url'));
        request.onload = function () {
            console.log('TERMS OF SERVICE XHR RESULT: ', request.responseText);
            if (request.status === 200) {
                (0, _loginShared.throwModal)({
                    html: '<div>' + request.responseText + '</div>',
                    title: tosLink.getAttribute('data-title')
                });
            } else {
                console.error('There was an error fetching the Privacy Policy!');
            }
        };
        request.onerror = function () {
            console.error('There was an error fetching the Privacy Policy!');
        };
        request.send();
    });
    //Handle Rapid Reg Form Toggle
    var rapidRegSection = document.getElementById('rapid-reg');
    var rapidRegLoginSection = document.getElementById('rapid-login');
    var addedGrecap = false;

    var loginGrecapOnload = function loginGrecapOnload() {
        try {
            document.getElementById('grecapholder').classList.add('popd');
        } catch (e) {}
    };

    var ensureGrecapWrap = function ensureGrecapWrap() {
        var language = 'en';
        try {
            language = document.querySelector('#rapidreg [name=loginLang]').value;
        } catch (e) {}
        (0, _GoogleRecaptchaHelper.ensureGrecap)({
            mainEl: document.getElementById('g-recaptcha-wr'),
            resetEl: document.getElementById('g-recaptcha-reset'),
            succCb: function grecapSuccCb() {
                clearMyFb(document.querySelector(formEls.frm));
            },
            resetCb: grecaptcha.reset,
            lang: language
        });
    };

    var showHideForms = function showHideForms(showReg) {
        if (showReg) {
            if (!addedGrecap) {
                (0, _GoogleRecaptchaHelper.setupGrecaptcha)(loginGrecapOnload);
                addedGrecap = true;
            }
            rapidRegLoginSection.classList.remove("formShow");
            rapidRegSection.classList.add("formShow");
            window.history.pushState('reg page', 'Manhunt', '/signup');
            var canGet = (0, _Browser.canGetBrowserLoc)();
            canGet.then(function (result) {
                var canGet = result.success;
                var grantState = result.state;
                if (canGet) {
                    if (grantState === 'prompt') {
                        (0, _loginShared.throwModal)({
                            html: '<p style="margin-top:0;">' + window.fbTrs.shareLoc1 + '</p>\n                                <p>' + window.fbTrs.shareLoc2 + '</p>',
                            title: window.fbTrs.plsShareLoc,
                            addClass: 'narrow',
                            closeCallback: tryGetLocData
                        });
                    } else {
                        // console.log('we can get location from browser');
                        tryGetLocData();
                    }
                } else {
                    console.log('browser location was denied access by user', canGet, grantState);
                }
            }, function () {
                // console.log('browser location was denied access!!', e);
                tryGetLocData();
            });
        } else {
            window.history.pushState('login page', 'Manhunt', '/login');
            rapidRegSection.classList.remove("formShow");
            rapidRegLoginSection.classList.add("formShow");
        }
    };

    var rlog_form = void 0;
    var h = void 0;
    if (mhMediaQuery.isMax800()) {
        try {
            rlog_form = rapidRegLoginSection.querySelector('form');
            h = document.createElement('input');
            h.setAttribute('type', 'hidden');
            h.name = 'login_on_mobile_sub800';
            h.value = true;
            rlog_form.appendChild(h);
        } catch (e) {}
    }

    var handleRrToggle = function handleRrToggle(evt) {
        var action = evt.target.getAttribute('data-action');
        var fd = void 0;
        switch (action) {
            case "rapidRegForm":
                showHideForms('showReg');
                GOOGLE_ANAL('send', 'event', 'rr-switch-form-to', 'rapidreg');
                break;
            case "loginForm":
                showHideForms();
                fd = getFrmDta();
                if (fd && (fd.username || fd.password || fd.email)) {
                    GOOGLE_ANAL('send', 'event', 'rr-switch-form-to', 'login-w-regdata-entered');
                } else {
                    GOOGLE_ANAL('send', 'event', 'rr-switch-form-to', 'login');
                }
                break;
            default:
                console.error('invalid action for login toggle button: ', action);
        }
        window.scrollTo(0, 0);
    };

    var rapidRegFormToggles = document.querySelectorAll('.formToggleBtn');
    L && (window.rapidRegFormToggles = rapidRegFormToggles);
    if (rapidRegFormToggles.length) {
        rapidRegFormToggles.forEach(function (el) {
            el.addEventListener('click', handleRrToggle);
        });
    }

    // show/hide reg or login
    var cNames = CookieHelper.getAllNames();
    var doneLogin = false;
    cNames.forEach(function (n) {
        if (n.match(/MHDoneLogin/) || n.match(/cookname/)) {
            doneLogin = true;
        }
    });

    var forceReg = false;
    if (location.search.match(/showreg/)) {
        forceReg = true;
    }
    if (location.pathname.match(/\/signup/)) {
        forceReg = true;
    }

    var forceLogin = false;
    if (location.pathname.match(/^\/login/)) {
        forceLogin = true;
    }

    if (!doneLogin && !forceLogin || forceReg) {
        showHideForms('showReg');
    }

    var csLink = document.getElementById('custsvcfoot');
    csLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var title = csLink.getAttribute('data-title'),
            html = document.getElementById('customerServiceModalContent').innerHTML.trim();
        (0, _loginShared.throwModal)({
            html: html,
            title: title,
            addClass: 'narrow'
        });
    });

    var setupRotator = false;

    if (window.location.pathname !== '/aboutus' && window.location.pathname !== '/logout') {
        setupRotator = true;
    }

    if (setupRotator) {
        ///@todo TOP SECTION FOR ROTATING IMAGES
        var picClkPrfx = 'altpic_';
        var picCtr = 0;
        var numPics = 4;
        var topSec = document.querySelector('[data-hook=login_register]');
        var rotatePicClass = function rotatePicClass() {
            if (window.pageYOffset > 760) {
                return;
            }
            topSec.classList.add('newpichid');
            setTimeout(function () {
                topSec.classList.remove(picClkPrfx + picCtr);
                picCtr++;
                picCtr = picCtr < numPics ? picCtr : 0;
                topSec.classList.remove('newpichid');
                topSec.classList.add(picClkPrfx + picCtr);
            }, 300);
        };
        var picRotInt = void 0;
        window.rotatePicClass = rotatePicClass;
        window.rotateStart = function () {
            picRotInt = setInterval(rotatePicClass, 6000);
        };
        if (window.innerWidth >= 768) {
            window.rotateStart();
        }
        // topSec.classList.add(picClkPrfx + '4');
        window.rotateStop = function () {
            clearInterval(picRotInt);
        };
        window.bg = function (n) {
            [0, 1, 2, 3, 4].forEach(function (i) {
                topSec.classList.remove(picClkPrfx + i);
            });
            topSec.classList.add(picClkPrfx + n);
        };
    } // end setupRotator

    // back-to-top widget
    var floatie = document.querySelector("#floatie");
    var scr2topHelper = new ScrollToTopHelper();
    scr2topHelper.bindEl(floatie);
    actOnScrPos.setThreshold(400);
    actOnScrPos.setAboveCallback(function () {
        floatie.classList.add('fadedOut');
    });
    actOnScrPos.setBelowCallback(function () {
        floatie.classList.remove('fadedOut');
    });

    // FORM VALIDATION:
    var checkUnAvail = function checkUnAvail() {
        var name = document.querySelector(formEls.uname).value.trim();
        var url = '/api/en/profiles/' + name.trim() + '/usernameAvailable';
        return new Promise(function (resolv, rej) {
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.setRequestHeader('Content-Type', 'application/json');
            req.onload = function () {
                if (req.status >= 200 && req.status < 400) {
                    resolv(name);
                    GOOGLE_ANAL('send', 'event', 'rr-uname-check', 'success');
                } else {
                    GOOGLE_ANAL('send', 'event', 'rr-uname-check', 'fail-inuse');
                    rej();
                }
            };
            req.onerror = function () {
                GOOGLE_ANAL('send', 'event', 'rr-uname-check', 'error');
                rej();
            };
            req.send();
        });
    };
    var checkEmail = function checkEmail() {
        var email = document.querySelector(formEls.em).value.trim();
        var encEmail = email.replace('.', '__DOT__');
        var url = '/api/en/avail/email/' + encEmail;
        return new Promise(function (resolv, rej) {
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.setRequestHeader('Content-Type', 'application/json');
            req.onload = function () {
                if (req.status >= 200 && req.status < 400) {
                    resolv(email);
                    GOOGLE_ANAL('send', 'event', 'rr-email-check', 'success');
                } else {
                    GOOGLE_ANAL('send', 'event', 'rr-email-check', 'fail-inuse');
                    rej();
                }
            };
            req.onerror = function () {
                GOOGLE_ANAL('send', 'event', 'rr-email-check', 'error');
                rej();
            };
            req.send();
        });
    };
    var disJoinBtn = function disJoinBtn(enable) {
        var b = document.querySelector('#rapidregsubmit');
        if (enable) {
            b.removeAttribute('disabled');
        } else {
            b.setAttribute('disabled', true);
        }
    };
    var formHasErrs = function formHasErrs() {
        var els = document.querySelector('form .formElems .regFb');
        return els ? true : false;
    };
    var setFb = function setFb(_ref) {
        var afterEl = _ref.afterEl,
            beforeEl = _ref.beforeEl,
            txt = _ref.txt,
            isError = _ref.isError;

        var insKeyw = 'afterend';
        var targEl = void 0;
        if (afterEl && afterEl.insertAdjacentElement) {
            targEl = afterEl;
        } else if (beforeEl && beforeEl.insertAdjacentElement) {
            insKeyw = 'beforebegin';
            targEl = beforeEl;
        } else {
            console.error('setFb called incorrectly, no afterEl or beforeEl');
        }
        if (!txt) {
            console.error('setFb called incorrectly, no txt string passed');
        }
        clearMyFb(targEl, 'immediate');
        var d = document.createElement('div');
        d.className = 'regFb';
        if (isError) {
            d.classList.add('err');
            targEl.classList.remove('succ');
            targEl.classList.add('err');
        } else {
            d.classList.add('succ');
            targEl.classList.remove('err');
            targEl.classList.add('succ');
        }
        d.innerHTML = txt;
        d.onclick = function (evt) {
            clearFb(evt.target);
        };
        targEl.insertAdjacentElement(insKeyw, d);
        disJoinBtn();
    };
    var clearFb = function clearFb(el, immediate) {
        if (el) {
            if (immediate) {
                el.remove();
            } else {
                if (el.classList) {
                    el.classList.add('fadeOut');
                    setTimeout(function () {
                        el.remove();
                        if (!formHasErrs()) {
                            disJoinBtn('enable');
                        }
                    }, 550);
                }
            }
        } else {
            console.error('error in clearFb: bad el arg');
        }
    };
    var clearMyFb = function clearMyFb(el, immediate) {
        // console.log('clearMyFb: ', el, immediate);
        var fbEl = el && el.nextSibling;
        var idStr = '#' + el.id;
        var formElKey = Object.keys(formEls).find(function (k) {
            return formEls[k].match(idStr);
        });
        if (formElKey && frmValidRules[formElKey].placeErrorAfter) {
            fbEl = document.querySelector(frmValidRules[formElKey].placeErrorAfter) && document.querySelector(frmValidRules[formElKey].placeErrorAfter).nextSibling;
        } else {
            fbEl = el && el.nextSibling;
        }
        if (fbEl.classList && fbEl.classList.contains('regFb')) {
            clearFb(fbEl, immediate);
        }
    };
    var setTfFbIcn = function setTfFbIcn(el, isGood) {
        if (el && el.classList) {
            if (isGood === 'valid') {
                el.classList.remove('err');
                el.classList.add('succ');
            } else if (isGood === 'clear') {
                el.classList.remove('err');
                el.classList.remove('succ');
            } else {
                el.classList.add('err');
                el.classList.remove('succ');
            }
        } else {
            console.error('bad el in set-textfield-feeback-icon');
        }
    };
    var formEls = {
        uname: '#reg-name',
        pwd: '#reg-password',
        em: '#reg-email',
        age: '#reg-age',
        tosagree: '#tosagree',
        frm: '#g-recaptcha-wr'
    };
    var getTestType = function getTestType(tst) {
        var t = typeof tst === 'undefined' ? 'undefined' : _typeof(tst);
        var ret = void 0;
        switch (t) {
            case 'object':
                if (tst.compile) {
                    ret = 'regex';
                }
                break;
            case 'function':
                ret = 'function';
                break;
        }
        return ret;
    };
    var frmValidRules = {
        uname: {
            tests: {
                plsEnterName: /^.+$/,
                nameCharViol: /^[_a-zA-Z0-9]+$/,
                nameTooShort: /^[_a-zA-Z0-9]{5}[_a-zA-Z0-9]+$/,
                nameTooLong: /^[_a-zA-Z0-9]{0,20}$/,
                nameNotAvail: checkUnAvail
            }
        },
        pwd: {
            placeErrorAfter: '[data-hook="pwd-strength-indic"]',
            tests: {
                plsEnterPwd: /^.+$/,
                pwdFailsReqs: function pwdFailsReqs(s) {
                    try {
                        (0, _passwordValidator.requirementsPass)(s);
                        return true;
                    } catch (e) {
                        L && console.log('pwd-valid FAIL: ', e);
                        return false;
                    }
                }
            }
        },
        em: {
            tests: {
                plsEnterEm: /^.+$/,
                emInvalid: _DryFunctions.emailRegx,
                emBlkLst: checkEmail
            }
        },
        age: {
            tests: {
                plsEnterAge: /^.+$/,
                ageRangeBad: function ageRangeBad(n) {
                    n = parseInt(n, 10);
                    return n > 17 && n < 100;
                }
            }
        },
        tosagree: {
            getVal: function getVal() {
                return document.getElementById('tosagree').checked ? 'true' : 'false';
            },
            placeErrorAfter: '#toswrapr',
            tests: {
                youMustAgree: function youMustAgree(n) {
                    return n === 'true';
                }
            }
        },
        frm: {
            getVal: function getVal() {
                /* global grecaptcha */
                var ret = '';
                try {
                    ret = grecaptcha && grecaptcha.getResponse();
                } catch (e) {
                    console.error('frm.getVal: ', e);
                    ret = '';
                }
                return ret;
            },
            tests: {
                recapFail: function recapFail(str) {
                    return !!str;
                }
            }
        }
    };
    var doValidations = function doValidations(name, blankOk) {
        var errors = [];
        var failErr = false;
        var hasVerr = false;
        if (!Object.keys(frmValidRules).includes(name)) {
            console.error('bad name in validate-rules function.');
            failErr = true;
        }
        var rules = frmValidRules[name] && frmValidRules[name].tests;
        if (!rules) {
            console.error('error in doValidations function: no rules found for: ', name);
            failErr = true;
        }
        var val = void 0,
            tmp = void 0,
            cstmVal = false;
        try {
            cstmVal = frmValidRules[name].getVal ? true : false;
            val = cstmVal ? frmValidRules[name].getVal() : document.querySelector(formEls[name]).value;
            tmp = val.trim();
            // console.log(`val & tmp: "${val}", "${tmp}"`);
            if (!cstmVal && val !== tmp) {
                val = tmp;
                document.querySelector(formEls[name]).value = val;
            }
        } catch (e) {
            console.error('error in doValidations function: no value from el with id: ', formEls[name]);
            failErr = true;
        }
        if (failErr) {
            return void 0;
        }
        Object.keys(rules).forEach(function (k) {
            var isBlank = false;
            var erObj = {};
            if (hasVerr) {
                return;
            }
            if (blankOk && !val) {
                isBlank = true;
            }
            var tt = getTestType(rules[k]);

            if (tt === 'regex') {
                if (!val.match(rules[k])) {
                    hasVerr = true;
                    erObj[k] = isBlank;
                    errors.push(erObj);
                }
            } else if (tt === 'function') {
                if (!rules[k](val)) {
                    hasVerr = true;
                    erObj[k] = isBlank;
                    errors.push(erObj);
                }
            } else {
                console.error('bad rule type in doValidations: ', k, tt);
            }
        });
        return errors && errors.length ? errors : true;
    };
    var api2localFb = {
        nameNotAvail: {
            reg: /^Sorry! That name is not available|Sorry, the name .+ is already being used/,
            elKey: 'uname'
        },
        nameCharViol: {
            reg: /^Your member name may only contain letters/,
            elKey: 'uname'
        },
        nameTooShort: {
            reg: /^Your member name must be at least/,
            elKey: 'uname'
        },
        nameTooLong: {
            reg: /^Your member name cannot be longer/,
            elKey: 'uname'
        },
        pwdTooShort: {
            reg: /^Your password must be at least/,
            elKey: 'pwd'
        },
        pwdTooLong: {
            reg: /^Your password can't be more/,
            elKey: 'pwd'
        },
        plsEnterPwd: {
            reg: /^Please enter a password/,
            elKey: 'pwd'
        },
        plsEnterEm: {
            reg: /^you must enter an email/,
            elKey: 'em'
        },
        emInvalid: {
            reg: /^Your email address is invalid/,
            elKey: 'em'
        },
        emThrowaway: {
            reg: /^This email is a known throwaway or/,
            elKey: 'em'
        },
        emNoExist: {
            reg: /^This email does not exist or/,
            elKey: 'em'
        },
        emBlkLst: {
            reg: /^email address can not be used/i,
            elKey: 'em'
        },
        plsEnterAge: {
            reg: /^Please enter your age to/,
            elKey: 'age'
        },
        ageRangeBad: {
            reg: /^Please enter an age between/,
            elKey: 'age'
        },
        recapFail: {
            reg: /^Recaptcha Failed/,
            elKey: 'frm'
        }
    };
    var apiSpclErr = [/Trying to get property of non-object/i];
    var apiErrSetFb = function apiErrSetFb(str) {
        var elId = void 0,
            txtKey = void 0,
            hasGenErr = false;
        if (!str) {
            return false;
        }
        apiSpclErr.forEach(function (re) {
            if (str.match(re)) {
                GOOGLE_ANAL('send', 'event', 'rr-login-page', 'general-error');
                hasGenErr = true;
            }
        });
        if (hasGenErr) {
            displGenFb();
            return;
        }
        Object.keys(api2localFb).forEach(function (k) {
            if (str.match(api2localFb[k].reg)) {
                elId = formEls[api2localFb[k].elKey];
                txtKey = k;
            }
            if (k === 'recapFail') {
                // special case
                try {
                    grecaptcha.reset();
                } catch (e) {}
            }
        });
        if (elId && txtKey) {
            GOOGLE_ANAL('send', 'event', 'rr-api-validation-err', txtKey === 'frm' ? 'grecaptcha' : txtKey);
            setFb({
                afterEl: document.querySelector(elId),
                isError: true,
                txt: window.fbTrs[txtKey]
            });
        } else {
            console.error('apiErrSetFb error: no match found for ', str);
        }
    };
    var vdateFfs = function vdateFfs(name, blankOk) {
        if (window.forceValid) {
            ///@todo DEV REMOVE THIS !!
            return true;
        }
        var ret = false;
        if (!name) {
            return Object.keys(frmValidRules).reduce(function (acc, cur) {
                return acc && vdateFfs(cur);
            }, true);
        }
        if (!Object.keys(frmValidRules).includes(name)) {
            console.error('bad name in validate-form-fields function.');
            return void 0;
        }
        var errors = doValidations(name, blankOk);
        var hasNonBlankErr = false;
        if (errors !== true) {
            errors.forEach(function (obj) {
                var key = Object.keys(obj)[0];
                var blankSkipped = obj[key];
                if (blankSkipped) {
                    return;
                } else {
                    hasNonBlankErr = true;
                }
                GOOGLE_ANAL('send', 'event', 'rr-fe-validation-err', name === 'frm' ? 'grecaptcha' : name);
                setFb({
                    afterEl: document.querySelector(frmValidRules[name].placeErrorAfter || formEls[name]),
                    isError: true,
                    txt: window.fbTrs[key]
                });
            });
            if (!hasNonBlankErr) {
                ret = 'allblank';
            }
        } else {
            ret = true;
        }
        return ret;
    };
    Object.keys(formEls).forEach(function (n) {
        var el = document.querySelector(formEls[n]);
        var evtType = void 0;
        if (el) {
            switch (el.type) {
                case 'checkbox':
                    evtType = 'click';
                    break;
                default:
                    evtType = 'blur';
            }
            el.addEventListener(evtType, function (evt) {
                var isVal = vdateFfs(n, BLANKVALOK);
                var prom = void 0;
                if (isVal === true) {
                    clearMyFb(evt.target);
                    if (n === 'uname') {
                        prom = checkUnAvail();
                        prom.then(function () {
                            setTfFbIcn(evt.target, 'valid');
                        }, function () {
                            setFb({
                                afterEl: document.querySelector(formEls.uname),
                                isError: true,
                                txt: window.fbTrs.nameNotAvail
                            });
                        });
                    } else {
                        setTfFbIcn(evt.target, 'valid');
                    }
                } else if (isVal === 'allblank') {
                    // do nothing, we're blank, so no check nor red-x
                    setTfFbIcn(evt.target, 'clear');
                    clearMyFb(evt.target);
                } else {
                    setTfFbIcn(evt.target);
                }
            });
            // el.addEventListener('touchstart', (evt) => {
            //     const elm = evt && evt.target;
            //     if (elm) {
            //         if (!elm.value || !elm.value.trim()) {
            //             return;
            //         }
            //     }
            //     elm.dispatchEvent(new Event('blur'));
            // });
        }
    });
    var pwdEl = document.querySelector('#reg-password');
    var pwdStrMeter = document.querySelector('[data-hook="pwd-strength-indic"]');
    var pwdStrMeterBar = document.querySelector('[data-hook="meter-bar-cover"]');
    var pwdStrScore = document.querySelector('[data-hook="ps-num"]');
    var checkMark = document.querySelector('[data-hook="pwd_pass_val_chk"]');
    var hideEye = document.querySelector('[data-hook="ps-eye"]');
    var hideEyeIcon = hideEye && hideEye.querySelector('img');
    var eyeSrcYes = '/assets/v6/img/icon/eye-yes.png';
    if (hideEye) {
        hideEye.addEventListener('click', function () {
            if (pwdEl.getAttribute('type') === 'password') {
                pwdEl.setAttribute('type', 'text');
                hideEyeIcon.setAttribute('src', eyeSrcYes.replace('-yes', '-no'));
            } else {
                pwdEl.setAttribute('type', 'password');
                hideEyeIcon.setAttribute('src', eyeSrcYes);
            }
        });
    }
    if (pwdStrMeter) {
        if (pwdEl) {
            pwdEl.addEventListener('focus', function () {
                pwdStrMeter.classList.remove('hidden');
            });
            pwdEl.addEventListener('blur', function () {
                var evt = new Event("maybehide", { "bubbles": false, "cancelable": true });
                pwdStrMeter.dispatchEvent(evt);
            });
        }
        pwdStrMeter.addEventListener('maybehide', function (e) {
            setTimeout(function () {
                if (pwdStrMeter.hasAttribute('data-donthide')) {
                    pwdStrMeter.classList.remove('hidden');
                    pwdStrMeter.removeAttribute('data-donthide');
                } else {
                    pwdStrMeter.classList.add('hidden');
                    setTimeout(function () {
                        pwdStrMeter.removeAttribute('data-donthide');
                    }, 2000);
                }
            }, 250);
        });
        pwdStrMeter.addEventListener('click', function () {
            pwdStrMeter.setAttribute('data-donthide', true);
            // pwdStrMeter.classList.remove('hidden');
        });
    }
    var scoreLabelMatrix = {
        0: 'Weak',
        40: 'OK',
        70: 'Strong',
        90: 'HOT !!!'
    };
    var getScoreLabel = function getScoreLabel(n) {
        var keys = Object.keys(scoreLabelMatrix);
        if (n >= keys[keys.length - 1]) {
            // highest score
            return scoreLabelMatrix[keys[keys.length - 1]];
        }
        for (var i = 0; i < keys.length; i++) {
            if (n < +keys[i + 1]) {
                return scoreLabelMatrix[keys[i]];
            }
        }
    };
    window.getScoreLabel = getScoreLabel;
    if (pwdEl) {
        pwdEl.addEventListener('keyup', function (evt) {
            var s = pwdEl.value.trim();
            try {
                (0, _passwordValidator.requirementsPass)(s);
                checkMark.classList.remove('hidden');
            } catch (e) {
                checkMark.classList.add('hidden');
            }
            var score = (0, _passwordValidator.strengthScore)(s);
            if (score < 0) {
                score = 0;
            } else if (score > 100) {
                score = 100;
            }
            if (score < 50) {
                pwdStrScore.classList.remove('dark');
            } else {
                pwdStrScore.classList.add('dark');
            }
            pwdStrScore.innerText = getScoreLabel(score);
            pwdStrMeterBar.setAttribute('style', 'width:' + (100 - score) + '%');
        });
    }
    try {
        var kupShwGrec = void 0;
        document.querySelector(formEls['em']).addEventListener('keyup', function () {
            if (kupShwGrec) {
                return;
            }
            if (!isGrecapVis()) {
                ensureGrecapWrap();
            }
            kupShwGrec = true;
        });
    } catch (e) {}
    var getFrmDta = function getFrmDta() {
        var f = document.querySelector('form#rapidreg');
        var data = {};
        var elIds = {
            username: 'reg-name',
            password: 'reg-password',
            email: 'reg-email',
            age: 'reg-age',
            tosagree: 'tosagree'
        };
        Object.keys(elIds).forEach(function (k) {
            try {
                var el = f.querySelector('#' + elIds[k]);
                if (el && el.type && el.type === 'checkbox') {
                    data[k] = el.checked;
                } else {
                    data[k] = el.value.trim();
                }
            } catch (e) {}
        });
        try {
            if (grecaptcha && grecaptcha.getResponse()) {
                data.recaptchaResponse = grecaptcha.getResponse();
            }
        } catch (e) {}
        if (window.navLatLonData && window.navLatLonData.coords) {
            data.loc_lat = window.navLatLonData.coords.latitude;
            data.loc_lon = window.navLatLonData.coords.longitude;
        } else {
            try {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (locationData) {
                        data.loc_lat = locationData.coords.latitude;
                        data.loc_lon = locationData.coords.longitude;
                    });
                }
            } catch (e) {}
        }
        return data;
    };
    L && (window.getFrmDta = getFrmDta);
    var isGrecapVis = function isGrecapVis() {
        var el = document.querySelector('#g-recaptcha-wr div');
        return el ? true : false;
    };
    var doRapReg = function doRapReg() {
        if (!isGrecapVis()) {
            ensureGrecapWrap();
        }
        var isValid = vdateFfs();
        var dtaObj = void 0,
            fd = void 0;
        if (!isValid) {
            return false;
        }
        dtaObj = getFrmDta();
        fd = new FormData();
        Object.keys(dtaObj).forEach(function (k) {
            fd.append(k, dtaObj[k]);
        });
        return new Promise(function (resolv, rej) {
            var req = new XMLHttpRequest();
            req.open('POST', '/api/rapidreg/s1', true);
            req.onload = function () {
                if (req.status >= 200 && req.status < 400) {
                    resolv(req);
                } else {
                    rej(req);
                }
            };
            req.onerror = function () {
                rej(req);
            };
            req.send(fd);
        });
    };
    L && (window.doreg = doRapReg);
    var rrForm = document.querySelector('form#rapidreg');
    if (rrForm) {
        document.querySelector('form#rapidreg').onsubmit = function (evt) {
            evt.preventDefault();
            var prm = doRapReg();
            if (prm) {
                showLoading();
                prm.then(function () {
                    hideLoading();
                    GOOGLE_ANAL('send', 'event', 'rr-reg-submit', 'success');
                    window.location.href = '/newuser-finish';
                }, function (data) {
                    hideLoading();
                    var r = JSON.parse(data.response);
                    if (r.error && r.error.message) {
                        GOOGLE_ANAL('send', 'event', 'rr-reg-submit', 'validation-fail');
                        apiErrSetFb(r.error.message);
                    }
                    console.error('FAILURE: registration problem: ', data);
                });
            } else {
                evt.preventDefault();
            }
            return false;
        };
    }
    var displGenFb = function displGenFb() {
        var par = document.querySelector('#rapidreg .formElems');
        if (par) {
            var d = document.createElement('div');
            d.className = 'fullFb';
            d.innerHTML = '<div><p>There has been an error.</p><p>Please reload the page and try again.</p><p>If the problem persists, please contact Customer Service at 1-866-424-9999</p></div>';
            par.appendChild(d);
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'm5';
            b.innerHTML = 'OK';
            b.onclick = function () {
                d.remove();
            };
            d.appendChild(b);
        } else {
            console.error('could not find #rapidreg .formElems in displGenFb');
        }
    };
    L && (window.fb = displGenFb);
    var showLoading = function showLoading() {
        var t = document.querySelector('[data-template-name=animated_loading_nine_grid]');
        var d = document.createElement('div');
        d.id = 'shwldgcubeanim';
        d.className = 'loadingIcon';
        d.innerHTML = t.innerHTML;
        document.body.appendChild(d);
    };
    var hideLoading = function hideLoading() {
        var el = document.querySelector('#shwldgcubeanim');
        if (el && el.remove) {
            el.remove();
        }
    };
    var setupLangMenus = function setupLangMenus() {
        var sels = document.querySelectorAll('#v5-langs-sel-log, #v5-langs-sel-reg');
        sels.forEach(function (sel) {
            sel.onchange = function (evt) {
                var id = sel.id; // apparently edge is having an issue with onchange sending an event :-(
                try {
                    evt.stopPropagation();
                    evt.preventDefault();
                } catch (e) {}
                var selct = document.querySelector('#' + id);
                var val = selct && selct.value;
                if (val && val === '-1') {
                    return;
                }
                // console.log('lang menu: ', evt.target.value);
                var url = '/changeLanguage/lang/' + val + '?backTo=' + encodeURIComponent(document.location.pathname + document.location.search);
                // console.log('url: ', url);
                window.location.href = url;
            };
        });
    };

    (0, _loginSharedEs.hijackFooterLinks)();
    setupLangMenus();

    var showTos = function showTos(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        var el = evt && evt.target,
            url = el && el.getAttribute && el.getAttribute('data-url');
        var title = void 0;
        try {
            title = el.innerHTML.trim();
        } catch (e) {}
        var oReq = new XMLHttpRequest();
        oReq.open("POST", url, true);
        oReq.onload = function () {
            var respData = void 0,
                d = void 0,
                m = void 0;
            if (oReq.status === 200) {
                respData = oReq.response;
                d = document.createElement('div');
                d.innerHTML = respData;
                m = (0, _loginShared.getV5ContentModal)({
                    title: title,
                    mainContent: d
                });
                m.classList.remove('hidden');
                m.querySelector('.v5contentModalStd').setAttribute('style', 'font-size:0.8em');
                document.body.appendChild(m);
                GOOGLE_ANAL('send', 'event', 'rr2-show-legal', url.split('/').find(function (t) {
                    return t ? true : false;
                }));
            } else {
                console.error('error fetching legal data 549: ', oReq);
            }
        };
        oReq.onerror = function () {
            console.error('error fetching legal data 553: ', oReq);
            GOOGLE_ANAL('send', 'event', 'rr2-show-legal', 'error');
        };
        oReq.send();
    };
    try {
        document.getElementById('pseudolink').addEventListener('click', function (e) {
            // console.log('pseudolink click: ', e);
            e.preventDefault();
            e.stopPropagation();
            showTos(e);
        });
    } catch (e) {}
};
module.exports = v5login;

},{"../../common/js/modules/Browser.es6":1,"../../common/js/modules/DryFunctions.es6":3,"../../common/js/modules/GoogleAnalyticsMH.es6":4,"../../common/js/modules/GoogleRecaptchaHelper.es6":5,"../../common/js/util/mhMatchMediaQuery":7,"../../common/js/util/passwordValidator.es6":8,"../../common/js/util/util_cookies":9,"../../common/js/widgets/ActOnScrollPosHelper.es6":10,"../../common/js/widgets/ScrollToTopHelper.es6":13,"./loginShared.es6":14,"./loginShared.es6.js":14}],16:[function(require,module,exports){
/*jshint unused:true, eqnull:true, curly:true */
/*jshint esversion: 5, devel: true */
/*jshint strict:true, browserify: true */
/*jshint -W097 */
'use strict';
window.easeOutCubic = window.easeOutCubic || function (currentIteration, startValue, changeInValue, totalIterations) {
    return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
};
var MicroEvent = require('../../common/js/plugins/MicroEvent');
var v5Login = require('./v5login.es6');
MicroEvent.mixin(document.body);
document.addEventListener('DOMContentLoaded', function () {
    v5Login();
});
},{"../../common/js/plugins/MicroEvent":6,"./v5login.es6":15}]},{},[16]);
